module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetMedium@2x.53ba15d.webp";